<div
  [ngClass]="{
    'premier': class === 'FIRST_CLASS',
    'amplus': class === 'AM_PLUS',
    'preferred': class === 'PREFERRED',
    'coachgen': class === 'COACH',
    'exit': class === 'EXIT_ROW'
  }"
>
    <ng-container *ngFor="let fare of fares">
      <ng-container  *ngIf="class === fare.fareName">
        <app-am-plane-fare-info  [seatMapSegment]="seatMapSegment" [class]="class" [positionClass]="fare.class"
          [icon]="fare.icon" [fareImage]="fare.fareImage" [fareName]="fare.fareName"></app-am-plane-fare-info>
      </ng-container>
    </ng-container>

  <!-- FILAS -->
  <div class="am-seats d-flex flex-column" *ngIf="seatDiv && seatDiv.rows">
    <app-am-row-plane
      [airplane]="airplane"
      [classrow]="class"
      [seatDiv2]="row"
      [index]="i"
      *ngFor="let row of seatDiv.rows; index as i"
    ></app-am-row-plane>
  </div>
</div>
